import * as React from "react";
import { ErrorStationListChunk } from "library/openapi/models";
import { Pagenation } from "./Pagination";
import { formatDate } from "./myClass/formatAnyDate";
import "../css/Common.css";

interface Props {
  errorStationListChunk: ErrorStationListChunk | undefined;
  clickDetail: any;
  clickPager: any;
}

function getErrorCss(
  stateStr: string | null | undefined
): string {
  let result = "";

  if (stateStr == "異常") {
    result = "bg-danger";
  }

  return result;
}

export const TableBind: React.FC<Props> = (props) => {
  if (!props.errorStationListChunk?.chunk) {
    return <div>データなし</div>;
  }

  //詳細ボタンクリックイベントハンドラ
  const clickEvent = (stationID: number) => {
    props.clickDetail(stationID);
  };

  //ページングイベントハンドラ
  const clickPagerEvent = (page: number) => {
    props.clickPager(page);
  };

  //rowデータ生成
  const rows = props.errorStationListChunk.chunk.map((station, index) => (
    <tr
      key={index}
      className={getErrorCss(
        station.state
      )}
    >
      <td>
        <button
          className="btn btn-sm btn-primary shadow-sm py-0"
          onClick={() => clickEvent(station.stationId)}
        >
          詳細
        </button>
      </td>
      <td>{station.no}</td>
      <td>{station.area}</td>
      <td>{station.stationNumber}</td>
      <td>{station.stationName}</td>
      <td>{station.manageSerial}</td>
      <td>{station.trigger}</td>
      <td>{station.matter}</td>
      <td>{formatDate(station.occurrence,"YYYY/MM/DD hh:mm")}</td>
      <td>{station.passedTimes}</td>
      <td>{station.state}</td>
      <td>{formatDate(station.recovered,"YYYY/MM/DD hh:mm")}</td>

    </tr>
  ));

  //ページャー生成
  const pager = () => {
    const pagenation = new Pagenation(
      props.errorStationListChunk?.page ?? 0,
      props.errorStationListChunk?.pageCount ?? 0
    );

    let pagerNumbers: number[] = pagenation.pageNumbers();

    let pagerElement: JSX.Element[] = [];

    let prevPage: number = (props.errorStationListChunk?.page ?? 0) - 1;
    let nextPage: number = (props.errorStationListChunk?.page ?? 0) + 1;

    if (prevPage < 0) {
      prevPage = 0;
    }

    if (nextPage >= (props.errorStationListChunk?.pageCount ?? 0)) {
      nextPage = (props.errorStationListChunk?.pageCount ?? 1) - 1;
    }

    pagerNumbers.forEach((page) => {
      if (page == (props.errorStationListChunk?.page ?? 0)) {
        pagerElement.push(
          <li className="page-item active" aria-current="page">
            <button
              type="button"
              className="page-link"
              onClick={() => clickPagerEvent(page)}
            >
              {page + 1}
            </button>
          </li>
        );
      } else {
        pagerElement.push(
          <li className="page-item">
            <button
              type="button"
              className="page-link"
              onClick={() => clickPagerEvent(page)}
            >
              {page + 1}
            </button>
          </li>
        );
      }
    });

    return (
      <ul className="pagination">
        <li className="page-item">
          <button
            type="button"
            className="page-link"
            onClick={() => clickPagerEvent(0)}
          >
            最初
          </button>
        </li>
        <li className="page-item">
          <button
            type="button"
            className="page-link"
            onClick={() => clickPagerEvent(prevPage)}
          >
            前へ
          </button>
        </li>
        {pagerElement}
        <li className="page-item">
          <button
            type="button"
            className="page-link"
            onClick={() => clickPagerEvent(nextPage)}
          >
            次へ
          </button>
        </li>
        <li className="page-item">
          <button
            type="button"
            className="page-link"
            onClick={() =>
              clickPagerEvent((props.errorStationListChunk?.pageCount ?? 1) - 1)
            }
          >
            最後
          </button>
        </li>
      </ul>
    );
  };

  const footerElement = pager();

  return (
    <table className="table table-sm table-hover">
      <thead className="bg-info">
        <tr>
          <th></th>
          <th>NO</th>
          <th>エリア</th>
          <th>局番</th>
          <th>局名</th>
          <th>デバイス<br/>管理番号</th>
          <th>トリガー</th>
          <th>障害内容</th>
          <th>発生時刻</th>
          <th>経過時間&#40;時&#41;</th>
          <th>状態</th>
          <th>復旧時刻</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
      <tfoot>
        <tr>
          <td colSpan={9}>{footerElement}</td>
        </tr>
      </tfoot>
    </table>
  );
};
